import DentistNavbar from './DentistNavbar';
export type { DentistNavbarProps } from './DentistNavbar';
export default DentistNavbar;
